/**
 * Animate innerHTML of element with start and end value using requestAnimationFrame
 * reference: https://css-tricks.com/animating-number-counters/
 * @param obj HTMLElement
 * @param start number
 * @param end number
 * @param duration number
 */
export const animateElementValue = (
  obj: HTMLElement,
  start: number,
  end: number,
  duration: number,
): void => {
  if (!obj) {
    return;
  }

  let startTimestamp = null;
  const step = (timestamp: number) => {
    if (!startTimestamp) startTimestamp = timestamp;
    const progress = Math.min((timestamp - startTimestamp) / duration, 1);
    obj.innerHTML = Math.floor(progress * (end - start) + start).toString();
    if (progress < 1) {
      window.requestAnimationFrame(step);
    }
  };
  window.requestAnimationFrame(step);
};
